import * as A from "../../node_modules/.pnpm/three@0.172.0/node_modules/three/build/three.tsl.js";
import { transformColor as n } from "../../utilities/transformations.js";
import { grain as B } from "../../helpers/grain.js";
import { getAspectCorrectedCoordinates as T } from "../../utilities/uv.js";
const U = {
  name: "Whisper2",
  collection: "whisper",
  tags: ["wave", "gradient", "soft"],
  props: {
    colorA: {
      type: String,
      default: "#ef798a",
      transform: n,
      description: "The primary color of the light."
    },
    colorB: {
      type: String,
      default: "#7c98b3",
      transform: n,
      description: "An accent color."
    },
    backgroundColor: {
      type: String,
      default: "#7e2e84",
      transform: n,
      description: "The background color."
    },
    speed: {
      type: Number,
      default: 1,
      description: "The speed of the light waves."
    }
  },
  fragmentNode: (o) => {
    const {
      vec4: r,
      uv: d,
      time: c,
      sin: u,
      cos: s,
      mix: t,
      abs: p,
      smoothstep: f,
      oneMinus: g
    } = A, e = d(), h = u(s(
      e.y.mul(Math.PI * 2).add(c.mul(o.speed.uniform).mul(0.2))
    ).mul(0.3).mul(s(c.mul(0.3)))).add(0.5), b = t(
      o.colorA.uniform,
      o.colorB.uniform,
      e.y
    ), C = p(e.x.sub(h)), a = f(
      0.5,
      0,
      C
    ), l = t(
      o.backgroundColor.uniform.mul(2),
      o.backgroundColor.uniform.mul(0.5),
      g(e.y)
    ), { correctedUV: y } = T(), k = B(0.8)(y), v = b.mul(a).mul(1).sub(k.mul(1)), w = ((i = r(0), m = r(0)) => i.add(m).sub(i.mul(m)))(l, v);
    return r(
      t(
        l,
        w,
        a
      ),
      1
    );
  }
};
export {
  U as componentDefinition,
  U as default
};
